<empathy-preview
  [welcomeScreenActive]="translatationsService.welcomeScreenActive$()"
  [endPageScreenActive]="translatationsService.endPageScreenActive$()"
  [editorForm]="translatationsService.editorForm"
  [activeQuestion]="translatationsService.activeQuestionForm$()?.value"
></empathy-preview>
